/* =========================================================
   AAYRAANI SHOPIFY THEME — theme.js
   Cart uses Shopify's native /cart.js AJAX API (no custom storage).
========================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav ---------- */
  var hamburger = document.getElementById('hamburger');
  var mainNav = document.getElementById('mainNav');
  if (hamburger && mainNav) {
    hamburger.addEventListener('click', function () {
      var open = mainNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
      document.body.classList.toggle('nav-open', open);
    });
    mainNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        mainNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded','false');
        document.body.classList.remove('nav-open');
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Sticky header shadow / back to top ---------- */
  var backToTop = document.getElementById('backToTop');
  window.addEventListener('scroll', function () {
    if (backToTop) backToTop.classList.toggle('show', window.scrollY > 500);
  });
  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Testimonial slider ---------- */
  var track = document.getElementById('testiTrack');
  var dotsWrap = document.getElementById('testiDots');
  if (track && dotsWrap) {
    var slides = track.children.length;
    var current = 0;
    for (var i = 0; i < slides; i++) {
      var dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', function (idx) {
        return function () { goToSlide(idx); };
      }(i));
      dotsWrap.appendChild(dot);
    }
    function goToSlide(idx) {
      current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      Array.prototype.forEach.call(dotsWrap.children, function (d, di) {
        d.classList.toggle('active', di === idx);
      });
    }
    if (slides > 1) {
      setInterval(function () {
        goToSlide((current + 1) % slides);
      }, 5000);
    }
  }

  /* ---------- Product filter tabs (featured products section) ---------- */
  var filterBar = document.getElementById('filterBar');
  if (filterBar) {
    var filterBtns = filterBar.querySelectorAll('.filter-btn');
    var gridItems = document.querySelectorAll('#productGrid .product-grid-item');
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.dataset.filter;
        gridItems.forEach(function (item) {
          item.classList.toggle('hide', filter && item.dataset.collection !== filter);
        });
      });
    });
  }

  /* =========================================================
     CART — Shopify AJAX Cart API
  ========================================================= */
  var cartOverlay = document.getElementById('cartOverlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartBtn = document.getElementById('cartBtn');
  var tabCartBtn = document.getElementById('tabCartBtn');
  var cartCloseBtn = document.getElementById('cartCloseBtn');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
  }
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (tabCartBtn) tabCartBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function showToast(msg) {
    var toast = document.getElementById('miniToast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  function updateCartCount(count) {
    document.querySelectorAll('#cartCount, #tabCartCount').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('zero', count === 0);
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var body = document.getElementById('cartDrawerBody');
        var foot = document.getElementById('cartDrawerFoot');
        if (!body) return;
        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
          if (foot) foot.style.display = 'none';
          return;
        }
        if (foot) foot.style.display = '';
        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-line" data-key="' + item.key + '">' +
            '<div class="cart-line-media">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>' +
            '<div class="cart-line-info">' +
            '<h4>' + item.product_title + '</h4>' +
            '<p class="cart-line-price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-line-qty">' +
            '<button class="cart-qty-btn cart-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button class="cart-qty-btn cart-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '<button class="cart-line-remove" data-key="' + item.key + '">Remove</button>' +
            '</div></div></div>';
        });
        body.innerHTML = html;
        var totalEl = document.getElementById('cartTotal');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        bindLineEvents();
      });
  }

  function formatMoney(cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, window.moneyFormat) : '₹' + (cents / 100).toFixed(2);
  }

  function bindLineEvents() {
    document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.qty, 10);
        changeQty(btn.dataset.key, Math.max(0, qty));
      });
    });
    document.querySelectorAll('.cart-line-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.dataset.key, 0); });
    });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCartDrawer(); });
  }

  function addToCart(variantId, btn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      showToast('Added to cart');
      if (btn) {
        btn.classList.add('added');
        var original = btn.textContent;
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); }, 1500);
      }
      refreshCartDrawer();
      openCart();
    }).catch(function () {
      showToast('Could not add to cart');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn) {
      e.preventDefault();
      addToCart(btn.dataset.variantId, btn);
    }
  });

  bindLineEvents();

  /* =========================================================
     ENQUIRY FORM -> WhatsApp
  ========================================================= */
  var enquiryForm = document.getElementById('enquiryForm');
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = document.getElementById('enqName').value;
      var phone = document.getElementById('enqPhone').value;
      var interest = document.getElementById('enqInterest').value;
      var message = document.getElementById('enqMessage').value;
      var waNumber = enquiryForm.dataset.waNumber || '919608168734';
      var text = 'Hello Aayraani, I would like to enquire.\n' +
        'Name: ' + name + '\nPhone: ' + phone + '\nInterested in: ' + interest +
        (message ? '\nMessage: ' + message : '');
      window.open('https://wa.me/' + waNumber + '?text=' + encodeURIComponent(text), '_blank');
    });
  }
});
